import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Authenticate } from '../common/sessionGate';
import DashboardViewer from '../features/dashboard-v1/DashboardViewer';

export const resolveDashboardLocationId = (params) =>
  params.id || params['*']?.split('/').filter(Boolean)[0] || null;

function DashboardTab() {
  const navigate = useNavigate();
  const locationId = resolveDashboardLocationId(useParams());

  useEffect(() => {
    if (!locationId) navigate('/');
  }, [locationId, navigate]);

  return locationId ? <DashboardViewer locationId={locationId} /> : null;
}

export default Authenticate(DashboardTab);
